import { apiClient } from '../core/client';
import queryString from 'query-string';

export const fetchLeaderboard = async (params) => {
  const purifiedParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v != undefined && v != '')
  );
  const res = await apiClient(
    `${process.env.REACT_APP_API_URL}telemetry_dashboard_data/leaderboard/?${queryString.stringify(
      purifiedParams
    )}`
  );

  return res.json();
};
